import { render } from "./CategoriesItem.vue?vue&type=template&id=3e77aee6&scoped=true"
import script from "./CategoriesItem.vue?vue&type=script&lang=js"
export * from "./CategoriesItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e77aee6"]])

export default __exports__